import type { FaireProductEntity } from "../../entity_types/product";

export const p_bbfaa8za8a: FaireProductEntity = {
  token: "p_bbfaa8za8a",
  type: "product",
  name: "Arizona Squishy Saguaro Keychains with Counter Display",
  brandToken: "b_40uiyujpi6",
  brandName: "Plushology® by RGU",
  imageUrl:
    "https://cdn.faire.com/fastly/8079da87a577fa1f49ecd6d1bc6d0e53a904596b416d1ff3d2597cc1c2a8e57d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ac2a2343d6219bf2efbfb5cd0b19035c3935d633cadf5046a8c37cf3a3d2cbd7.jpeg",
    "https://cdn.faire.com/fastly/932f042cae47f5c584a80fbd86e84d5e2ef03ad989149de5334925e5571cecec.jpeg",
    "https://cdn.faire.com/fastly/43e211a0fa538cefdcbefd9727a0cb150f289dcda4e4db78f319be5e5eb3472b.jpeg",
    "https://cdn.faire.com/fastly/cc3b87d56760bd128c1405fb3b4560e876509e32de599cf4ce7d754518d79315.jpeg",
    "https://cdn.faire.com/fastly/3e628db50e37b9cda1345323f8700e08a6f917fd9bd6ba07beac536b73a7e92c.jpeg",
  ],
  priceDollars: 5.2,
  description:
    " This cute Squishy Saguaro keychain will stick with you forever! Crafted from an ultra-soft, plush fabric it is sure to bring a smile to anyone’s face. The lobster clasp makes it easy to take this little cactus anywhere you go. These happy little guys come with a display! ",
  tags: [],
  msrpDollars: 11.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:23.984Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
